import { render, staticRenderFns } from "./IconRowItem.vue?vue&type=template&id=452a2be7&"
import script from "./IconRowItem.vue?vue&type=script&lang=js&"
export * from "./IconRowItem.vue?vue&type=script&lang=js&"
import style0 from "./IconRowItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports